import React, { useContext } from "react";

import { Preview } from "@creatomate/preview";
import { Icon, PlainButton } from "@culturehq/components";

import { ElementSource } from "chq";
import { removeSubtitlesElements, syncSubtitles } from "../../sidebar/tabs/subtitle/utils";
import { CreatomateContext } from "../../contexts/VideoStudioContext";
import { VIDEO_TYPE } from "../../utils/constants";

interface RedoButtonProps {
  preview: Preview;
}

const RedoButton: React.FC<RedoButtonProps> = ({
  preview
}) => {
  const { data: { subtitles }, handleUpdateData } = useContext(CreatomateContext);

  const deleteSubtitles = async (video: ElementSource) => {
    handleUpdateData({ blockSubtitles: true, originalReplacedVideo: video.source });
    await removeSubtitlesElements(handleUpdateData, preview, subtitles, true);
  };

  const handleRedo = async () => {
    const creatomateJson = preview.getSource();
    const video = creatomateJson.elements.find((element: ElementSource) => element.type === VIDEO_TYPE && element.name.startsWith("media-"));

    await preview.redo();
    syncSubtitles(handleUpdateData, preview, subtitles);

    const updatedCreatomateJson = preview.getSource();
    if (updatedCreatomateJson?.source !== video?.source) deleteSubtitles(video);
  };

  return (
    <PlainButton onClick={handleRedo} disabled={!preview.state?.redo}>
      <Icon icon="linkedin-share" />
    </PlainButton>
  );
};

export default RedoButton;
